import styles from "../styles/productPage.module.css";

const ProductPageSkeleton = () => {
  return (
        <div className={`${styles.container} ${styles.skeletoncont}`}>
          <div className={`skeleton ${styles.mainSwiperSkeleton}`}></div>
          <div className={`skeleton ${styles.thumbSwiperSkeleton}`}></div>
        </div>
  );
}

export default ProductPageSkeleton;
